export default __webpack_public_path__ + "static/game-image-2-eng-4f6ea249991a411d39bf686b9095da94.png";